/* eslint-disable react/prop-types */
import React from 'react';
import { makeStyles } from '@mui/styles';
import { GDMHTForm } from '../index';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function NavTabs(props) {
  const classes = useStyles();
  const { ids } = props;

  return (
    <div className={classes.root}>
      <GDMHTForm
        ids={ids}
        nextStep={props.nextStep}
        prevStep={props.prevStep}
      />
    </div>
  );
}
